import { createContext, useState } from "react";

const ALERT_TIME = 3000;

const initialState = {
  text: "",
  type: "",
  confirm: true,
};

const MessageContext = createContext({
  ...initialState,
  setMessage: () => {},
});

export const MessageProvider = ({ children }) => {
  const [state, setState] = useState({
    text: "",
    type: "",
    confirm: false,
  });

  const setMessage = ({ text = "", type = "", confirm, ...rest }) => {
    setState({ text, type, confirm, ...rest });

    if (!confirm) {
      setTimeout(() => {
        setState({ text: "", type: "", confirm: "" });
      }, ALERT_TIME);
    }
  };

  return (
    <MessageContext.Provider value={{ ...state, setMessage }}>
      {children}
    </MessageContext.Provider>
  );
};

export default MessageContext;
